import { user } from 'app/user';
import { ENDPOINT_JOBALARM } from 'app/endpoints';

export const success = (email, jobAlarmId) => ({
    jobAlarmId,
    imagePath: '/assets/images/bell.svg',
    subtitle: `Neue passende Jobs für deine Suche werden jetzt an <b>${email}</b>
                geschickt. ${!user.isLoggedIn() ? 'Melde dich an, um deinen Job-Alarm zu verwalten.' : ''}`,
    redirectLink: ENDPOINT_JOBALARM,
    loginButton: !user.isLoggedIn(),
});

export const checkMail = () => ({
    imagePath: '/assets/images/emptyState/envelope-letter.svg',
    title: 'Schau in deinen Posteingang!',
    subtitle: `Öffne bitte den Link in deiner <b>Bestätigungs-E-Mail</b>,
               um deine Anmeldung für den Job-Alarm abzuschließen.`,
});

export const limitExceeded = () => {
    const loggedOutText = '<a class="m-resultState__loginLink">Melde dich an</a>, um deine Job-Alarme anzusehen oder zu ändern.';

    return {
        imagePath: '/assets/images/emptyState/SomethingWentWrong_Error.svg',
        title: 'Du hast schon 15 Job-Alarme',
        subtitle: `Das Aktivieren des Job-Alarms ist leider nicht möglich,
                   weil du die <b>maximale Anzahl schon erreicht</b> hast.
                   ${!user.isLoggedIn() ? loggedOutText : ''}`,
        redirectLink: ENDPOINT_JOBALARM,
    };
};

export const alreadyExists = (jobAlarmId) => {
    const loggedOutText = '<a class="m-resultState__loginLink">Melde dich an</a>, um deinen Job-Alarm anzusehen.';

    return {
        jobAlarmId,
        imagePath: '/assets/images/emptyState/SomethingWentWrong_Error.svg',
        title: 'Job-Alarm schon vorhanden',
        subtitle: `Ein Job-Alarm mit diesen Suchkriterien wurde für diese E-Mail-Adresse bereits erstellt.
                   ${!user.isLoggedIn() ? loggedOutText : ''}`,
        redirectLink: ENDPOINT_JOBALARM,
    };
};

export const generalError = () => ({
    imagePath: '/assets/images/emptyState/SomethingWentWrong_Error.svg',
    title: 'Bitte versuche es später noch einmal',
    subtitle: 'Bei der Erstellung des Job-Alarms ist leider ein Fehler aufgetreten.',
});

export const jobAlarmResultState = {
    success,
    checkMail,
    limitExceeded,
    alreadyExists,
    generalError,
};
